function Traits() {
  return (
    <section className="colored" id="TRAITS&SPECIES">
      <p
        className="section_title"
        style={{
          textAlign: "center",
        }}
      >
        <span>Boost your NFT collection</span> on the Polygon/Ethereum Network
      </p>
      <br />
      <br />
      <img src="img/trait1.svg" alt="" className="traits_image" />
      <span className="section_text auto_right">
        <p className="green">Every Funky owner will be able to:</p>
        <li>Participate in Funkalo!!</li>
        <li>
          Funkalo is a blockchain game, aimed at teaching our members how to
          climb the economic ladder of society through a play, learn and earn
          approach.
        </li>
        <li>
          You earn funkies governance token(funkalo) as you play the game and
          move to different economic class.
        </li>
        <li>
          The mind is the standard of the man, hence the game is geared towards
          giving you the mindset needed to get to the upper economic class.
        </li>
        <li>
          Funkies collectibles believe teaching more people about these life
          skills means empowering them as knowledge is power. It also means
          making wealth and good living available to our community!!
        </li>
        <br />
        <br />
        <br />
        <br />
        <a
          href="https://discord.gg/p4vyXHNWzd"
          target="blank"
          className="nav_link button_type free_button"
        >
          JOIN THE DISCORD
        </a>
      </span>
    </section>
  );
}

export default Traits;
